import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-xl-8" }
const _hoisted_3 = ["min"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "table-responsive mt-4" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "align-middle text-center small" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "align-middle" }
const _hoisted_12 = { class: "align-middle text-end text-nowrap" }
const _hoisted_13 = { class: "align-middle text-end text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "period-text" }, "Periodo: ", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          id: "fromDt",
          name: "fromDt",
          class: "form-control w-25 input-date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.fromDate]
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "period-text" }, "al", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control w-25 input-date",
          id: "toDt",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event)),
          min: _ctx.fromDate
        }, null, 8, _hoisted_3), [
          [_vModelText, _ctx.toDate]
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-info btn-search",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getData())),
          disabled: !_ctx.fromDate || !_ctx.toDate
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fas fa-search" }, null, -1)
        ]))], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "fw-bold" }, [
            _createElementVNode("th", { class: "col-2 text-center" }, "Fecha"),
            _createElementVNode("th", { class: "" }, "Usuario"),
            _createElementVNode("th", { class: "" }, "Concepto"),
            _createElementVNode("th", { class: "" }, "Patrocinador"),
            _createElementVNode("th", { class: "text-center" }, "Valor"),
            _createElementVNode("th", { class: "text-center" }, "Pagado")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_ctx.loadingData)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("td", {
                  colspan: "6",
                  class: "text-center"
                }, "Loading ...", -1)
              ]))]))
            : (_ctx.getIncomeReport)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getIncomeReport, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "",
                    key: row.date
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatDate(row.date.toDate())), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(row.username), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(row.concept), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(row.enroller), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(row.value), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(row.paid), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}